import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-layout full-height min-height" }
const _hoisted_2 = { class: "io-mfe-ig-header" }
const _hoisted_3 = {
  key: 0,
  class: "io-mfe-ig-banner"
}
const _hoisted_4 = {
  key: 1,
  class: "io-mfe-ig-body full-height min-height flex column min-height"
}
const _hoisted_5 = {
  key: 2,
  class: "io-mfe-ig-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_grouper_title = _resolveComponent("grouper-title")!
  const _component_grouper_banner = _resolveComponent("grouper-banner")!
  const _component_grouper_body = _resolveComponent("grouper-body")!
  const _component_grouper_footer = _resolveComponent("grouper-footer")!
  const _component_loading_bar = _resolveComponent("loading-bar")!
  const _component_loading_error = _resolveComponent("loading-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_grouper_title)
    ]),
    (_ctx.readOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_grouper_banner)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_grouper_body)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_grouper_footer)
        ]))
      : (!_ctx.loadingTimeout)
        ? (_openBlock(), _createBlock(_component_loading_bar, { key: 3 }))
        : (_openBlock(), _createBlock(_component_loading_error, { key: 4 }))
  ]))
}